import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store, Select } from '@ngxs/store';
import { ProprieteState, SetCurrentPage } from '../../propriete.state';
import { Observable } from 'rxjs';
import { slideRevealAnimation } from '../../../shared/animations/_index';
import { SetCurrentCodePage } from '../../../shared/navigation.state';
import { ShowLoader, HideLoader } from '../../../shared/personne.state';
import { ProprieteModele } from '../../modeles/proprieteModel';
import { ToolCapaciteService } from '../../../tool-capacite/tool-capacite.service';

@Component({
  selector: 'app-liste-proprietes',
  templateUrl: './liste-proprietes.component.html',
  styleUrls: ['./liste-proprietes.component.scss'],
  animations: [slideRevealAnimation],
  standalone: false
})
export class ListeProprietesComponent implements OnInit {
  @Select(ProprieteState.proprietes)
  proprietes$: Observable<ProprieteModele[]>;

  capaciteStatus$: Observable<any> = this._toolCapaciteService.donneesResultat$;
  capaciteStatus: any;

  @Select(state => state.propriete.loaded) loaded$: Observable<boolean>;

  loaded = false;

  btnAddProperty: boolean;

  listeProprietes: Array<ProprieteModele>;

  constructor(
    private readonly _router: Router,
    private readonly _store: Store,
    private readonly _toolCapaciteService: ToolCapaciteService
  ) {}

  ngOnInit(): void {
    this._store.dispatch(new SetCurrentCodePage('liste'));
    this._store.dispatch(new SetCurrentPage('liste'));
    this.loaded$.subscribe(isLoaded => {
      this._store.dispatch(isLoaded ? new HideLoader() : new ShowLoader());
      this.loaded = isLoaded;
    });

    this.proprietes$.subscribe(proprietes => {
      //Deep copy de l'objet afin de ne pas affecter le type de propriete du target
      this.listeProprietes = JSON.parse(JSON.stringify(proprietes));
      // le type de la propriete est supprimée dans le formualire. vérifier si l'opération suivante reste utile.
      // for (const propriete of this.listeProprietes) {
      //   propriete.type = this._donneeReferencesService.getTypeProprieteeSelected(propriete.type, 'propertyID')[
      //     'typeProprietee'
      //   ];
      // }
      this.displayNextStep();
    });

    this.fetchCapaciteStatus();
    this.btnAddProperty = this.listeProprietes.length > 0;
  }

  navigateTo(target: string): void {
    this._router.navigateByUrl(target);
  }

  displayNextStep(): void {
    if (this.listeProprietes.length > 0) {
      this.btnAddProperty = true;
    } else {
      this.btnAddProperty = false;
    }
  }

  get hasCapacite() {
    return this.capaciteStatus && this.capaciteStatus.isCompleted;
  }

  get versementRealiste() {
    return this.capaciteStatus ? this.capaciteStatus.versementMensuel : null;
  }

  get versementMaximal() {
    return this.capaciteStatus ? this.capaciteStatus.versementMaximal : null;
  }

  private fetchCapaciteStatus() {
    const capaciteStatusSelector = this.capaciteStatus$;

    capaciteStatusSelector.subscribe(data => {
      this.capaciteStatus = {
        isCompleted: data.isCompleted,
        versementMensuel: data.versementMensuelRealiste,
        isTooLow: data.isTooLow,
        isTooHigh: data.isTooHigh
      };
    });
  }
}
